function formatCategory(category) {
  if (typeof category !== 'string') {
    throw new Error('Category cannot be empty')
  }
  const categoryStripped = category.replace(/\//g, '')

  switch (categoryStripped) {
    case 'health-wellness':
      return 'Wellness'
    case 'health-fitness':
      return 'Fitness'
    case 'health-food':
      return 'Food'
    default:
      return null
  }
}

export default formatCategory



// WEBPACK FOOTER //
// ./src/utils/formatCategory.js